import { Box } from '@/components/Box/Box';
import { PageFooter } from '@/components/Page/PageFooter/PageFooter';
import { Paginator } from '@/components/Paginator/Paginator';
import { useGetSearchParams } from '@/hooks/useGetSearchParams';
import { COLORS } from '@/styles/colors';
import { Typography } from '@/components/Typography/Typography';
import { InvoicesTable } from './InvoicesTable/InvoicesTable';
import { NavigationLink } from '@/components/NavigationLink/NavigationLink';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getSinglePaymentInvoices } from '../../api/api';
import { getListData } from '@/helpers/helpers';

// TODO v23.0.0 remove interval when BE find another solution to update invoices data
const INVOICE_REFETCH_INTERVAL = 20000;

type SubscriptionInvoicesType = {
  onCustomerPortalNavigate: () => void;
};

export const SubscriptionInvoices = ({ onCustomerPortalNavigate }: SubscriptionInvoicesType) => {
  const searchParams = useGetSearchParams();

  const { data, isPending } = useQuery({
    queryKey: ['get_single_payment_invoices', searchParams],
    queryFn: () => getSinglePaymentInvoices(searchParams),
    placeholderData: keepPreviousData,
    refetchInterval: INVOICE_REFETCH_INTERVAL,
  });

  const { list, hasPagination, totalCount } = getListData(data?.body, searchParams);

  return (
    <Box display='flex' flexDirection='column' rowGap='20px'>
      <Box display='flex' flexDirection='column' rowGap='20px'>
        <Box display='flex' flexDirection='column'>
          <Typography color={COLORS.grey[950]} fontWeight='semibold'>
            Subscription Invoices
          </Typography>
          <Typography color={COLORS.grey[650]} variant='bodySmall'>
            You can view all recurring subscription invoices in the{' '}
            <NavigationLink to={''} onClick={onCustomerPortalNavigate}>
              Stripe Customer Portal.
            </NavigationLink>
          </Typography>
        </Box>
        <Box display='flex' flexDirection='column'>
          <Typography color={COLORS.grey[950]} fontWeight='semibold'>
            Overage Wires Invoices
          </Typography>
          <Typography color={COLORS.grey[650]} variant='bodySmall'>
            You can view all invoices for overage sending and/or receiving in the table below.
          </Typography>
        </Box>
      </Box>

      <InvoicesTable items={list} isLoading={isPending} />
      {hasPagination && (
        <PageFooter>
          <Paginator page={searchParams.page} limit={searchParams.limit} total={totalCount} />
        </PageFooter>
      )}
    </Box>
  );
};
